import LoadingIcon from "../LoadingIcon";

export default function LoadingPage() {
  return (
    <div className="w-full h-full flex justify-center mt-5">
      <LoadingIcon icon="three-dots" className="w-10" />
    </div>
  );
}
